export enum PermissionCategory {
  REPORTING = 'reporting',
  USERS_AND_GROUPS = 'users-and-groups',
  ACCOUNT_SETTINGS = 'account-settings',
  RESOURCES = 'resources',
  CONTENT = 'content',
  TRAINING = 'training',
}

export enum PermissionLevel {
  NONE = 'none',
  VIEW = 'view',
  EDIT = 'edit',
}

export enum ScopeMode {
  GROUPS = 'groups',
  MANAGER = 'manager',
  ALL = 'all',
}

export const SCOPED_CATEGORIES: PermissionCategory[] = [
  PermissionCategory.REPORTING,
  PermissionCategory.USERS_AND_GROUPS,
  PermissionCategory.TRAINING,
];

export const VIEW_ONLY_CATEGORIES: PermissionCategory[] = [
  PermissionCategory.RESOURCES,
];

export type CustomRolePermission = {
  category: PermissionCategory;
  level: PermissionLevel;
};

export type CustomRole = {
  id: string;
  accountId: string;
  name: string;
  scopeMode?: ScopeMode | null;
  permissions: CustomRolePermission[];
  created: Date;
  updated?: Date | null;
};

export type CustomRoleResult = {
  customRole: CustomRole;
  assignedUserCount: number;
};

export type SaveCustomRoleRequest = {
  name: string;
  scopeMode?: ScopeMode | null;
  permissions: CustomRolePermission[];
};
